import Api from "./api";
import { ajaxJWT } from "@/utils/request";

export function SETTING_query(parameter) {
  return ajaxJWT({
    url: Api.setting_query,
    method: "post",
    data: parameter
  });
}
export function SETTING_update(parameter) {
  return ajaxJWT({
    url: Api.setting_update,
    method: "post",
    data: parameter
  });
}

export function SETTING_user_query(parameter) {
  return ajaxJWT({
    url: Api.setting_user_query,
    method: "post",
    data: parameter
  });
}

export function SETTING_user_modify(parameter) {
  return ajaxJWT({
    url: Api.setting_user_modify,
    method: "post",
    data: parameter
  });
}
